import React from 'react'
import {useGameState} from '../../hooks/useGameState'
import WrittenText from '../common/WrittenText'
import Button from '../common/Button'
import {logEvent} from '../../helpers/analytics'

export default function Complete() {
  const {word, tries} = useGameState()

  return (
    <>
      <p>Congratulations, you got </p>
      <WrittenText>{word}</WrittenText>
      <p> with {tries.length} tries!</p>
      <hr/>
      <p>
        <Button onClick={() => {
          logEvent('word_definition', {word})
          window.open(formatGoogleUrl(word), '_tab')
        }}>
          See definition
        </Button>
      </p>
      <p/>
    </>
  )
}

function formatGoogleUrl(word) {
  return `https://www.google.com/search?q=define+${word}#dobs=${word}`
}